/* Yatas Bedding NL — collection page behaviour.
 * Filter pills: auto-submit for checkbox/sort, click-outside to close the
 * dropdowns, and only one open at a time.
 */
(function () {
  'use strict';

  function init(root) {
    const form = root.querySelector('[data-filter-form]');
    if (!form) return;

    // Checkbox pills and the sort select submit immediately.
    form.querySelectorAll('[data-autosubmit]').forEach((el) => {
      el.addEventListener('change', () => form.submit());
    });

    const drops = Array.from(form.querySelectorAll('details.ybn-pill--drop'));

    // Only one dropdown open at a time.
    drops.forEach((d) => {
      d.addEventListener('toggle', () => {
        if (!d.open) return;
        drops.forEach((other) => {
          if (other !== d) other.open = false;
        });
      });
    });

    // Click outside closes them.
    document.addEventListener('click', (e) => {
      if (form.contains(e.target)) return;
      drops.forEach((d) => (d.open = false));
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') drops.forEach((d) => (d.open = false));
    });
  }

  // "Verder lezen" on the SEO block. Deliberately a button, not a hidden
  // checkbox - see the comment in ybn-main-collection.liquid.
  function initSeo() {
    document.querySelectorAll('[data-seo-toggle]').forEach((btn) => {
      const body = document.querySelector('#' + btn.getAttribute('aria-controls'));
      if (!body) return;

      // Nothing to expand: the text already fits inside the clamp.
      if (body.scrollHeight <= body.clientHeight + 2) {
        btn.hidden = true;
        return;
      }

      btn.addEventListener('click', () => {
        const open = body.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  const start = () => {
    document.querySelectorAll('.ybn-collection').forEach(init);
    initSeo();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
